/* eslint-disable jsx-a11y/anchor-is-valid */
import { forwardRef, type LinkHTMLAttributes } from "react";

const FavoritesIconButtonInnner = (
  props: LinkHTMLAttributes<any>,
  ref: any
) => (
  <a
    {...props}
    ref={ref}
    className="navigation-icons"
    id="favorite-item"
    href="#"
  >
    <img
      src="/assets/user_site/theme_v3/navigation_bar/favorites.png"
      alt="account"
    />
  </a>
);

export const FavoritesIconButton = forwardRef(FavoritesIconButtonInnner);
